export default "__VITE_ASSET__KylSI2hJ__"